import { useEffect } from "react";
// import logo from "./logo.svg";
import "./tailwind.css";
import "./App.scss";
import { SupportedLanguages } from "./common/controls/lang-switcher";
import { IntlProvider } from "react-intl";
import { getUserLocalization, LANG_RESOURCES } from "./locales";
import MainAppLayout from "./layouts/_main-app-layout";
import { USER_LANG_KEY } from "./locales/keys";
import { useLocalStorageState } from "./common/utils/local-storage-hook";
import AppRouter from "./routes/router";

function App() {
 console.count("App render");

  const [lang, setLanguage] = useLocalStorageState<SupportedLanguages>(
    USER_LANG_KEY,
    () => getUserLocalization(),
  );

  const handleLanguageChange = (nextLang: SupportedLanguages) => {
    setLanguage(nextLang);
  };

  useEffect(() => {
    console.log("App commit");
  }, []);

  useEffect(() => {
    console.log("App language changed:", lang);
  }, [lang]);

  return (
    <IntlProvider locale={lang} messages={LANG_RESOURCES[lang]}>
      <MainAppLayout onLanguageChange={handleLanguageChange} language={lang}>
        <AppRouter />
      </MainAppLayout>
    </IntlProvider>
  );
}

export default App;
